import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useLazyLineNotificationServicesQuery } from '@/app/api/generated';
import { CheckModal } from '@/components/Elements/CheckModal/CheckModal';
import { REACT_APP_CUCON_API_DOMAIN } from '@/config';
import themeTokens from '@/config/theme-tokens.js';

const MODALS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};
const brandBackgroundColor = themeTokens.color.brand.background;

export const NotificationCancel = () => {
  const navigate = useNavigate();
  const [fetchLineNotificationServices] =
    useLazyLineNotificationServicesQuery();
  const [openModalName, setOpenModalName] = useState<string | null>(null);
  const { notificationUserId } = useParams();

  useEffect(() => {
    // 通知先登録API用のAPIキーを取得する
    fetchLineNotificationServices()
      .unwrap()
      .then((result) => {
        const apiKey =
          result.notificationServices[0].notificationSettings[0].settings[
            'api-key'
          ];
        const apiUrl = `${REACT_APP_CUCON_API_DOMAIN}/notification/${notificationUserId}`;

        fetch(apiUrl, {
          method: 'DELETE',
          headers: {
            'api-Key': apiKey,
          },
          credentials: 'include',
        })
          .then(async (result) => {
            const data = await result.json();
            if (data.state === 'success') {
              setOpenModalName(MODALS.SUCCESS);
            } else {
              setOpenModalName(MODALS.FAILURE);
            }
          })
          .catch((reason) => {
            console.error(reason);
            setOpenModalName(MODALS.FAILURE);
          });
      })
      .catch((reason) => {
        console.error(reason);
        setOpenModalName(MODALS.FAILURE);
      });
  }, [fetchLineNotificationServices, notificationUserId]);

  const handleExecute = () => {
    navigate('/');
  };

  return (
    <>
      <div
        className={
          'absolute left-[5px] top-[5px] inline-block items-center rounded-[4px] p-[2px]'
        }
      >
        <div className="pointer-events-none fixed right-0 z-[100] flex w-full flex-col items-center justify-center text-center">
          {openModalName === MODALS.SUCCESS && (
            <CheckModal
              title={'完了'}
              description={'通知設定の解除が完了しました'}
              backgroundColor={brandBackgroundColor}
              handleExecute={handleExecute}
              executeButtonName="アプリを開く"
            />
          )}
          {openModalName === MODALS.FAILURE && (
            <CheckModal
              title={'失敗'}
              description={'通知設定の解除が失敗しました'}
              backgroundColor={brandBackgroundColor}
              handleExecute={handleExecute}
              executeButtonName="アプリを開く"
            />
          )}
        </div>
      </div>
    </>
  );
};
